import produce from 'immer';
import { parse as parseParams } from 'hub-http/helpers/params';
import * as AssetBusinessType from 'marketplace-ui-assets-core/constants/AssetBusinessType';
import * as AssetPageFeature from 'marketplace-ui-assets-core/constants/AssetPageFeature';
import * as AssetPageType from 'marketplace-ui-assets-core/constants/AssetPageType';
import * as Tiers from 'marketplace-ui-common/constants/groupTags/Tiers';
import * as AssetSort from '../../constants/AssetSort';
import filterIncludes from '../../../utils/filterIncludes';
import includes from '../../../utils/includes';
import replaceAll from '../../../utils/replaceAll';
import { DEFAULT_ASSET_QUERY_LIMIT } from '../../constants/AssetQuery/AssetQuery';
import { MODULE_CONTENT_TYPE_VALUES } from '../../../modules/constants/ModuleContentType';
import { ModuleQuery } from '../../../modules/records/ModuleQuery';
import { ThemeQuery } from '../../../themes/records/ThemeQuery';
import { getOffsetFromPageNumber } from '../../../utils/pagination';
import { isParsedThemesRouteParams } from '../isAssetType';
export function getComputedQuery(offeringType, parsedParams, location) {
  const {
    pageNumber
  } = parsedParams;
  const {
    search
  } = location;
  const offset = getOffsetFromPageNumber(pageNumber, DEFAULT_ASSET_QUERY_LIMIT);
  let queryObj = getAssetQueryFromLocation(search);
  queryObj = produce(queryObj, draft => {
    draft.offset = offset;

    if (isParsedThemesRouteParams(parsedParams)) {
      const {
        businessType,
        pageFeature,
        pageType
      } = parsedParams;
      if (businessType) draft.businessTypes = [businessType];
      if (pageType) draft.pageTypes = [pageType];
      if (pageFeature) draft.pageFeatures = [pageFeature];
    } else {
      const {
        category
      } = parsedParams;
      if (category) draft.categories = [category];
    }
  });
  return offeringType === 'MODULE' ? new ModuleQuery(queryObj) : new ThemeQuery(queryObj);
}

function toArray(param) {
  return Array.isArray(param) ? param : [param];
}

function getAssetQueryFromLocation(search) {
  const params = parseParams(replaceAll(search.slice(1), '+', '%20'));
  const queryObj = Object.keys(params).reduce((record, paramKey) => {
    if (!/^eco_/i.test(paramKey)) {
      return record;
    }

    const paramValue = params[paramKey];
    const unprefixedParamKey = paramKey.replace(/^eco_/i, '');
    parseQueryValue(record, unprefixedParamKey, paramValue);
    return record;
  }, {});
  return queryObj;
}

const AssetBusinessTypeValues = Object.values(AssetBusinessType);
const AssetPageFeatureValues = Object.values(AssetPageFeature);
const AssetPageTypeValues = Object.values(AssetPageType);
const AssetSortValues = Object.values(AssetSort);
const TierTypeValues = Object.values(Tiers);

function parseQueryValue(record, key, value) {
  switch (key) {
    case 'businessTypes':
      record.businessTypes = filterIncludes(toArray(value), AssetBusinessTypeValues);
      break;

    case 'pageTypes':
      record.pageTypes = filterIncludes(toArray(value), AssetPageTypeValues);
      break;

    case 'pageFeatures':
      record.pageFeatures = filterIncludes(toArray(value), AssetPageFeatureValues);
      break;

    case 'categories':
      record[key] = toArray(value);
      break;

    case 'contentTypes':
      record.contentTypes = filterIncludes(toArray(value), MODULE_CONTENT_TYPE_VALUES);
      break;

    case 'hasFreeSupport':
    case 'portalCompatible':
      record[key] = value === 'true' ? true : null;
      break;

    case 'tags':
    case 'providers':
      record[key] = toArray(value);
      break;

    case 'offeringIds':
      record.offeringIds = toArray(value).reduce((ids, id) => {
        const parsed = parseInt(id, 10);
        if (isNaN(parsed)) return ids;
        return ids.concat([parsed]);
      }, []);
      break;

    case 'planType':
      record.priceRange = null;
      record.planType = includes(['ONE_TIME', 'FREE'], value) ? value : null;
      break;

    case 'sortFields':
      record.sortFields = filterIncludes(toArray(value), AssetSortValues);
      break;

    case 'tiers':
      record.tiers = filterIncludes(toArray(value), TierTypeValues);
      break;

    case 'minOverallRating':
      {
        const parsedQueryValue = parseInt(value, 10);
        record.minOverallRating = !isNaN(parsedQueryValue) && parsedQueryValue > 0 && parsedQueryValue < 5 ? parsedQueryValue : null;
        break;
      }

    case 'priceRangeMin':
    case 'priceRangeMax':
      {
        if (record.planType) return;
        const priceRangeKey = key === 'priceRangeMin' ? 'minCents' : 'maxCents';
        record.priceRange = Object.assign({}, record.priceRange || {
          minCents: null,
          maxCents: null
        }, {
          [priceRangeKey]: parseInt(value, 10)
        });
        break;
      }

    case 'search':
      record.search = value;
      break;

    default:
      break;
  }
}